import {Injectable} from '@angular/core';

/**
 * Translations for form submit row translation service.
 */
@Injectable()
export class ButtonsTranslations {
  public i18nCancel: string = $localize`:@@general.button.cancel:Cancel`;
  public i18nContinue: string = $localize`:@@general.button.continue:Continue`;
  public i18nBack: string = $localize`:@@general.button.back:Back`;
  public i18nNext: string = $localize`:@@general.button.next:Next`;
  public i18nMerge: string = $localize`:@@general.button.merge:Merge`;
  public i18nSubmit: string = $localize`:@@general.button.submit:Submit`;
  public i18nCreateCustomer: string = $localize`:@@general.button.createCustomer:Create Customer`;
  public i18nIgnoreAndCreateNew: string = $localize`:@@general.button.ignoreAndCreateNew:Ignore & Create New`;
  public i18nToTixx: string = $localize`:@@general.button.toTixx:To Tixx`;
  public i18nCreate: string = $localize`:@@general.button.create:Create`;
  public i18nResetFilterSettings: string = $localize`:@@general.button.resetFilterSettings:Reset filter settings`;
  public i18nShowRequests: string = $localize`:@@general.button.showRequests:Show requests`;
  public i18nFilterOpenRequests: string = $localize`:@@general.button.filterOpenRequests:Filter open requests`;
  public i18nExecuteLotterySeating: string = $localize`:@@general.button.executeLotterySeating:Execute lottery and seating`;
  public i18nBackToRequestFiltering: string = $localize`:@@general.button.backToRequestFiltering:Back to request filtering`;
  public i18nCreateReservations: string = $localize`:@@general.button.createReservations:Create reservations`;
  public i18nNo: string = $localize`:@@general.button.no:No`;
  public i18nYes: string = $localize`:@@general.button.yes:Yes`;

  constructor() { }
}
